<div (keydown.Space)="$event.stopPropagation()">
    <form [formGroup]="createAppForm" class="new-connection" autocomplete="off">
        <div class="new-connection_step-container input-container ms-0">
            <div class="row">
                <div class="col-sm-6">
                    <div class="new-connection_step-title ms-0 font-14 mb-1">Email</div>
                    <div [ngClass]="{ hasError: isdisable === true }">
                        <input formControlName="Email" type="text" required
                            class="input-container_input input-container_input--thin font-14 set-position" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="new-connection_step-title ms-0 font-14 mb-1">Password</div>
                    <div [ngClass]="{ hasError: isdisable === true }">
                        <input formControlName="Password" type="password" required
                            class="input-container_input input-container_input--thin font-14 set-position" />
                    </div>
                </div>
                    <div class="col-sm-12">
                        <div class="companyName-list">
                          <label for="" class="input-container_label">Company Name</label>
                        <input
                        #companyId
                          type="text"
                          class="input-container_input input-container_input--select matselect-combobox"
                          placeholder="Search"
                          formControlName="CompanyName"
                          [matAutocomplete]="auto"
                          #trigger="matAutocompleteTrigger" matAutocompletePosition="below"
                          (blur)="onFocusOutEvent($event,trigger)"
                          (keydown)="stopSpace($event)"
                        />
                        <mat-autocomplete
                          #auto="matAutocomplete"
                          autoActiveFirstOption 
                          class="companyAutoComplete"                              
                        >
                          <mat-option
                          *ngFor="let option of filteredOptions | async"
                          [value]="option.companyName"
                          class="mat-option-override"
                          >
                          <app-company-list-item [company]="option"></app-company-list-item>
                          </mat-option>
                        </mat-autocomplete>
                        </div>
                      </div>
            </div>
        </div>
        <div class="new-connection_action">
            <app-button (click)="close.emit()" [buttonStyle]="'wire'">Cancel</app-button>
            <app-button
            [spin]="loading"
            [isDisabled]="createAppForm.invalid || !isValidCompany"
            (click)="connect3PL()"
              >Save</app-button
            >
          </div>
    </form>
</div>